import { Horizontal } from "Components/Horizontal";
import { VerticalRadio } from "Inputs/Radio";
import React from "react";
import { PaymentMethodOptions } from "SharedConstants";

export interface AgentBillingInputProps {
  IsAgencyBillOnly: boolean;
}

export function AgentBillingInput(
  props: AgentBillingInputProps & {
    isBankPaymentAllowed: boolean;
    fieldName: string;
  },
) {
  const paymentMethodOptions = [
    [PaymentMethodOptions.AgencyBilling, "Agency Billing (Pay Later)"],
    ...(props.IsAgencyBillOnly
      ? []
      : [
          [
            PaymentMethodOptions.PayNow,
            props.isBankPaymentAllowed
              ? "Credit Card or Bank Account (Pay Now)"
              : "Credit Card (Pay Now)",
          ],
        ]),
  ] as [string, string][];
  return (
    <Horizontal isRequired label="Agency Billing" shouldNotPadLabel>
      <div>
        <div style={{ marginBottom: "0.5em" }}>
          How would you like to pay for this policy?
        </div>
        <VerticalRadio
          fieldName={props.fieldName}
          options={paymentMethodOptions}
          value={
            props.IsAgencyBillOnly
              ? PaymentMethodOptions.AgencyBilling
              : undefined
          }
        />
      </div>
    </Horizontal>
  );
}
